import { CommPreferenceService } from '@weave/schema-gen-ts/dist/schemas/comm-preference/preference/v1/preference_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaCommPreferenceV1Service = bindHTTP(CommPreferenceService);
export const serviceName = 'comm-preference-v1' as const;
